import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BellRing, ChevronLeft, Lock, ShieldCheck, UserRound } from 'lucide-react';
import { HostActionRow } from '../../components/HostSettingsCard';
import StaffBottomNav from '../../components/StaffBottomNav';
import AdminBottomNav from '../../components/AdminBottomNav';
import StaffVenueHeader from '../../components/staff/StaffVenueHeader';
import { useBackTarget } from '../../hooks/useBackTarget';

const FONT = "'Inria Serif', serif";

export default function StaffAccountSettingsPage({ basePath = '/staff-app', navType = 'staff' }) {
  const navigate = useNavigate();
  const goBack = useBackTarget();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const prefix = navType === 'admin' ? 'staff-admin-account-settings' : 'staff-account-settings';
  const BottomNav = navType === 'admin' ? AdminBottomNav : StaffBottomNav;

  const items = [
    { label: 'Personal Information', icon: <UserRound size={22} color="var(--text-2)" strokeWidth={1.6} />, action: () => navigate(`${basePath}/account-settings/personal`), testId: `${prefix}-personal-button` },
    { label: 'Login & Security', icon: <ShieldCheck size={22} color="var(--text-2)" strokeWidth={1.6} />, action: () => navigate(`${basePath}/account-settings/security`), testId: `${prefix}-security-button` },
    { label: 'Privacy', icon: <Lock size={22} color="var(--text-2)" strokeWidth={1.6} />, action: () => navigate(`${basePath}/account-settings/privacy`), testId: `${prefix}-privacy-button` },
    { label: 'Notifications & History', icon: <BellRing size={22} color="var(--text-2)" strokeWidth={1.6} />, action: () => navigate(`${basePath}/account-settings/notifications`), testId: `${prefix}-notifications-button` },
  ];

  return (
    <div className="app-shell" data-testid={`${prefix}-page`} style={{ minHeight: '100dvh', backgroundColor: 'var(--app-bg)', paddingBottom: 120 }}>
      <StaffVenueHeader roleLabel={navType === 'admin' ? 'Admin staff' : 'Venue staff'} testIdPrefix={prefix} />
      <div style={{ padding: '14px 20px 0', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <button
          type="button"
          onClick={goBack}
          data-testid={`${prefix}-back-button`}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}
        >
          <ChevronLeft size={32} color="var(--text)" strokeWidth={1.7} />
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 16px' }}>
        <img src="/allure-logo.png" alt="Allure" style={{ width: 140, height: 122, objectFit: 'contain', marginTop: 6 }} />
        <h1 style={{ fontFamily: FONT, fontSize: 24, fontWeight: 700, color: 'var(--text)', textAlign: 'center', margin: '16px 0 24px', lineHeight: 1.15 }}>
          Account Settings
        </h1>
        <div style={{ width: '100%', maxWidth: 360, display: 'flex', flexDirection: 'column', gap: 14 }}>
          {items.map((item) => (
            <HostActionRow key={item.label} label={item.label} icon={item.icon} onClick={item.action} dataTestId={item.testId} />
          ))}
          <p data-testid={`${prefix}-account-id`} style={{ marginTop: 14, textAlign: 'center', fontFamily: FONT, fontSize: 16, color: 'var(--text-3)' }}>
            Account ID: {user.customer_id || '—'}
          </p>
        </div>
      </div>

      <BottomNav basePath={basePath} />
    </div>
  );
}